const appInfo = {
  name: process.env.REACT_APP_NAME,
  version: process.env.REACT_APP_VERSION,
  isDevelopment: process.env.NODE_ENV === 'development',
  appEnv: process.env.REACT_APP_ENV,
}

export default appInfo
